import Navigation from '@/components/Navigation';
import HeroSection from '@/components/HeroSection';
import AboutSection from '@/components/AboutSection';
import ExpertiseSection from '@/components/ExpertiseSection';
import ExperienceSection from '@/components/ExperienceSection';
import InsightsSection from '@/components/InsightsSection';
import ContactSection from '@/components/ContactSection';
import Footer from '@/components/Footer';
import TechBackground3D from '@/components/TechBackground3D';
import TrustedPartnersSection from '@/components/TrustedPartnersSection';
import Metrics from '@/components/Metrics';

const Index = () => {
  return (
    <div className='min-h-screen bg-background relative'>
      <TechBackground3D />
      <div className='relative z-10'>
        <Navigation />
        <main className='mt-[64px] md:mt-0'>
          <HeroSection />
          <Metrics />
          <AboutSection />
          <TrustedPartnersSection />
          <ExpertiseSection />
          <ExperienceSection />
          {/* <InsightsSection /> */}
          <ContactSection />
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default Index;
